// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-config .user-info span[data-v-14259d71]:first-child{display:inline-block;width:90px}.layout-config .card-item[data-v-14259d71]{width:420px}.layout-config .card-item .weChat-icon[data-v-14259d71]{color:#28c445}", ""]);
// Exports
module.exports = exports;
